/* jshint ignore:start */
(function ($, window, undefined) {

	App.previewBg = function () {
		if ($('.preview-bg[data-bg]')) {

			$('.preview-bg[data-bg]').each(function () {
				var b = $(this),
					c = b.data('bg'),
					d = $('body').data('image-ver');

				c.indexOf('ver=' + d) < 0 && (c.indexOf('?') >= 0 ? b.data('bg', b.data('bg') + '&ver=' + d) : b.data('bg', b.data('bg') + '?ver=' + d)),

				b.backstretch(b.data('bg'), {
					centeredX: !0,
					centeredY: !0,
					fade: 200
				});
			});
		}
	};

	/*
	 * Banners do topo do blog
	 */
	(function () {
	    'use strict';

	    $(".item-blog:eq(0)").addClass('active');

	    $('#ultimas-postagens .bts-box button').on('click', function () {
	        if ($(this).hasClass('next')) {
	            if ($(".item-blog.active").next('.item-blog').length) {
	                $(".item-blog.active").removeClass('active').next().addClass('active');
	            }
	        } else {
	            if ($(".item-blog.active").prev('.item-blog').length){
	                $(".item-blog.active").removeClass('active').prev().addClass('active');
	            }
            }
            
	    });
	    var listaPosts = $('#list-carousel');
	    listaPosts.owlCarousel({
	        stopOnHover: true,
	        items: 3,
	        animateOut: 'fadeOut',
	        animateIn: 'fadeIn',
	        margin: 0,
	        nav: false,
	        dots: true,
	        loop: true,
	        responsive: {
	            0: {
	                items: 1
	            },
	            479: {
	                items: 1
	            },
	            768: {
	                items: 1
	            },
	            980: {
	                items: 3
	            },
	            1024: {
	                items: 3
	            }
	        }
	    });

	   
	    $($("#list-carousel").find(".owl-item.active:eq(1)").get()).addClass('middle');
	
	    listaPosts.on('initialize.owl.carousel initialized.owl.carousel translated.owl.carousel', function (event) {
	        $(event.delegateTarget).find('.owl-item').removeClass('middle');
	        var item = $(event.delegateTarget).find(".owl-item.active:eq(1)").get();
	        $(item).addClass('middle');
	    });
	    

		$('.template-blog').imagesLoaded(function () {

			if ($('[data-bg]').each(function () {
				var b = $(this);

				b.on('backstretch.show', function () {
					b.parent().siblings('.content-link').fadeIn(200);
				});

				b.backstretch(b.data('bg'), {
					centeredX: !0,
					centeredY: !0,
					fade: 200
				});
			}),

			$('.post-slide').length) {
				var b = [],
					c = 0,
					d = [];

				$('.post-slide').each(function () {
					var e = $(this);

					b[c] = e.data('backstretch-bg'), 
					d[c] = {
					    link: e.data('link'),
					    desc: e.data('desc'),
						title: e.data('title')
					},
					c++;
				});

				b.length > 1 && ($('.blog-banner-bg').append('<ul class="bs-bullets"></ul>'),

					b.forEach(function () {
						$('.bs-bullets').append('<li></li>');
					}),

					$('.bs-bullets li').on('click', function () {
						$(this).parents('.blog-banner-bg').backstretch('show', $(this).index());
					}));

				$('.blog-banner-bg').on('backstretch.before', function (b, c, e) {
				    
				    $('.advise-blog .content h1').html(d[e].title);
				    $('.min-desc-banner').html(d[e].desc);
					$('.advise-blog .content a:not(".category-link")').attr('href', d[e].link);
					$(b.currentTarget).find('.bs-bullets > li.active').removeClass('active');
					$(b.currentTarget).find('.bs-bullets > li:eq(' + e + ')').addClass('active');
				});

				$('.blog-banner-bg').backstretch(b, {
					fade: 200
				});
			}

			App.previewBg();
		});

		$(window).on('resize', function () {

			var b = $('.blog-banner-bg').data('backstretch'),
				c = $('[data-bg]');

			b && b.resize(),

			c.each(function () {
				var b = $(this),
					c = b.data('backstretch');
				c && c.resize();
			});
		});

	}());

	/*
	 * Animação no banner do post
	 */

	(function () {
		'use strict';

		if ($('body').hasClass('template-blog')) {

			$(window).on('scroll', function () {
				var pos = $(this).scrollTop(),
					$pageHeader = $('.page-header'),
					$pageNav = $('.secondary-info');

				if (pos > $pageHeader.height()) {
					$pageNav.addClass('fixed');

					if (pos > $('.blog-content-wrapper').height()) {
						$pageNav.removeClass('fixed');
					}

				} else {
					$pageNav.removeClass('fixed');
				}

				/*if (!App.isMobile.any()) {

					var transformImage = $(window).scrollTop() * 0.0005 + 1;
					var translateImage = $(window).scrollTop() / 3 * (-1);
					var oapcityImage = ($(window).scrollTop() * 0.0025 - 1) * (-1);

					if (oapcityImage > -1) {
						$('.header-content').css({
							'transform': 'scale(' + transformImage + ') translate(-50%, ' + translateImage + 'px)',
							'opacity': oapcityImage
						});
					}
				}*/
			});

		}
	}());

	/*
	 * Função para carregar mais postagens
	 */

	(function () {
		'use strict';

		if ($('.blog-content-wrapper')) {

			var post = {},
				url,
				$btnLoadPosts = $('.blog-content-posts').find('.load-more');

			// Variáveis do botão carregar mais para posts da página inicial
			if ($('.blog-content-posts').hasClass('latest-posts')) {
				post = {
				    pagina: Math.round(jQuery('.last-post-box > article').length / 3),
				};
				url = '/Blog/ListarMaisPosts';
			}

			// Variáveis do botão carregar mais para posts da página interna
			if ($('.blog-content-posts').hasClass('others-posts')) {
                post = {
				    pagina: Math.round(jQuery('.last-post-box > article').length / 3)+1,
					categoriaId: $('.id-categoria').val(),
					idPostParaRemover: $('.id-post').val()
				};
				url = '/Blog/ListarMaisPostsDaCategoria';
			}

			$btnLoadPosts.on('click', function (event) {
				event.preventDefault();
                
				var $loadButton = $(this);
				post.pagina++;

				$.ajax({
					url: url,
					dataType: 'json',
					data: post,
					type: 'POST',
					beforeSend: function () {

						

						var $blogLoader = $('<div/>', {
							'class': 'spinner-loader'
						});

						//$blogLoader.appendTo('.latest-posts');
					}
				}).done(function (response) {

					if (response.retorno.length) {
					    $.each(response.retorno, function (index, post) {
					        var $postHTML = '';
							$postHTML += '<article itemscope itemprop="blogPost" itemtype="http://schema.org/BlogPosting" class="post-item">';
							$postHTML += '<a class="post-thumb" href="/blog/' + post.UrlAmigavel + '">';
							$postHTML += '<span class="post-date">';
							$postHTML += '<time itemprop="datePublished" datetime>' + post.DataAmigavel + '</time>';
							$postHTML += '</span>';
							$postHTML += '</a>';
							$postHTML += '<p class="post-category">' + post.PostCategoria.Nome + '</p>';
							$postHTML += '<h1 class="post-title" itemprop="headline">';
							$postHTML += '<a href="/blog/' + post.UrlAmigavel + '">' + post.Titulo + '</a>';
							$postHTML += '</h1>';

							$postHTML += '<p class="post-date2" itemprop="articleBody">' + post.DataAmigavel + '</p>';
							$postHTML += '</article>';
                            $($postHTML).insertBefore($loadButton);
						});

						if (response.retorno.length < 8) {
							$loadButton.fadeOut(300, function () {
								
							});
						}

						App.previewBg();
						$('.latest-posts').find('.spinner-loader').remove();
						$loadButton.fadeIn(300);
					}

				});
			});

		}

	}());

}(jQuery, window));
/* jshint ignore:end */